 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"agreements":"agreements","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~16f450fc":"allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~16f450fc","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~a39f1f36":"allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~a39f1f36","allergy~calendar~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~patien~791ef781":"allergy~calendar~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~patien~791ef781","allergy":"allergy","calendar~inspection":"calendar~inspection","inspection":"inspection","documents":"documents","ikp":"ikp","previous-appeal":"previous-appeal","research":"research","diagnosis":"diagnosis","diseases":"diseases","drugs":"drugs","group-conclusion~parameters":"group-conclusion~parameters","group-conclusion":"group-conclusion","interview":"interview","appointment~tasks":"appointment~tasks","appointment":"appointment","parameters":"parameters","online-consultations":"online-consultations","qr-codes":"qr-codes","tasks-results":"tasks-results","tasks~test":"tasks~test","tasks":"tasks","patients":"patients","calendar":"calendar","cabinet":"cabinet","login":"login","patients-schedule":"patients-schedule","print":"print","single-clinic":"single-clinic","statistics":"statistics","test":"test","total-monthly-report":"total-monthly-report"}[chunkId]||chunkId) + "." + {"agreements":"47cb9447","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~16f450fc":"0991a55d","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~a39f1f36":"9561a6f2","allergy~calendar~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~patien~791ef781":"68396957","allergy":"45130fc6","calendar~inspection":"8765e22a","inspection":"8bac621f","chunk-182c7a6a":"0cffe786","documents":"9e4c605b","ikp":"95b2189c","previous-appeal":"8c79a5a9","research":"5a1cb341","diagnosis":"a550c49f","diseases":"d716dfff","drugs":"2e7211b5","group-conclusion~parameters":"aa0933b3","group-conclusion":"bdfd1a85","interview":"6d080140","appointment~tasks":"3637c8bf","appointment":"d989a447","parameters":"2c885733","online-consultations":"9fdd7683","qr-codes":"008e1411","tasks-results":"5f01ff96","tasks~test":"6dcb00ff","tasks":"101c88f4","patients":"7969f537","calendar":"4161c994","cabinet":"9ffeabe2","chunk-12ff8ce5":"86ec9820","chunk-2eb2537a":"c82c2ed1","chunk-7add27e0":"9c6d752c","chunk-6e5c936c":"5f21f55a","login":"9a98197b","patients-schedule":"7314f7c1","print":"aa1f677a","single-clinic":"1ba88787","statistics":"5b672199","test":"87bf0119","total-monthly-report":"c313a931"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"agreements":1,"allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~16f450fc":1,"allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~a39f1f36":1,"allergy~calendar~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~patien~791ef781":1,"calendar~inspection":1,"inspection":1,"documents":1,"ikp":1,"research":1,"group-conclusion":1,"appointment~tasks":1,"appointment":1,"qr-codes":1,"tasks-results":1,"tasks":1,"patients":1,"calendar":1,"cabinet":1,"chunk-12ff8ce5":1,"chunk-2eb2537a":1,"chunk-7add27e0":1,"chunk-6e5c936c":1,"patients-schedule":1,"print":1,"statistics":1,"test":1,"total-monthly-report":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"agreements":"agreements","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~16f450fc":"allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~16f450fc","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~a39f1f36":"allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~a39f1f36","allergy~calendar~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~patien~791ef781":"allergy~calendar~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~patien~791ef781","allergy":"allergy","calendar~inspection":"calendar~inspection","inspection":"inspection","documents":"documents","ikp":"ikp","previous-appeal":"previous-appeal","research":"research","diagnosis":"diagnosis","diseases":"diseases","drugs":"drugs","group-conclusion~parameters":"group-conclusion~parameters","group-conclusion":"group-conclusion","interview":"interview","appointment~tasks":"appointment~tasks","appointment":"appointment","parameters":"parameters","online-consultations":"online-consultations","qr-codes":"qr-codes","tasks-results":"tasks-results","tasks~test":"tasks~test","tasks":"tasks","patients":"patients","calendar":"calendar","cabinet":"cabinet","login":"login","patients-schedule":"patients-schedule","print":"print","single-clinic":"single-clinic","statistics":"statistics","test":"test","total-monthly-report":"total-monthly-report"}[chunkId]||chunkId) + "." + {"agreements":"12265e4c","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~16f450fc":"726b3234","allergy~appointment~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~onl~a39f1f36":"105a24ed","allergy~calendar~diagnosis~diseases~documents~drugs~group-conclusion~ikp~inspection~interview~patien~791ef781":"743894ca","allergy":"31d6cfe0","calendar~inspection":"d1bd209f","inspection":"00a4ed52","chunk-182c7a6a":"31d6cfe0","documents":"ba56e3ee","ikp":"b0381d85","previous-appeal":"31d6cfe0","research":"c3a72598","diagnosis":"31d6cfe0","diseases":"31d6cfe0","drugs":"31d6cfe0","group-conclusion~parameters":"31d6cfe0","group-conclusion":"68816d28","interview":"31d6cfe0","appointment~tasks":"f48fba74","appointment":"0f72d795","parameters":"31d6cfe0","online-consultations":"31d6cfe0","qr-codes":"cef5a3cd","tasks-results":"402a6828","tasks~test":"31d6cfe0","tasks":"1428e650","patients":"61d76724","calendar":"870c4457","cabinet":"f3012517","chunk-12ff8ce5":"a7620c72","chunk-2eb2537a":"62641bfc","chunk-7add27e0":"a43f85f0","chunk-6e5c936c":"49b8c9b3","login":"31d6cfe0","patients-schedule":"479154aa","print":"aad50d82","single-clinic":"31d6cfe0","statistics":"84b51497","test":"726b3234","total-monthly-report":"27572302"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
